<template>
    <v-container fluid class="monitorSite stats-boxX elevation-2X px-4 fade-in">
        <v-layout class="page-body pt-6 admin-page bg-light-blue">
        <v-flex xs12>
            <h1>Manage Offices</h1>
            <v-flex xs12 class="horiz-margin-20">
             <v-row data-app wrap>
                <v-col sm="10" md="10">
                    <v-text-field
                    v-model="officename"
                    hide-details="false"
                    placeholder="Search by Office Name / OfficeAbbreviation / Agency / Program / Field / Branch for the current volume"
                    ></v-text-field>
                </v-col>
                <v-col sm="10" md="2" class="d-flex align-end">
                    <v-btn color="primary" dark @click="onSearchClicked">Search</v-btn>
                </v-col>
            </v-row>
            </v-flex>
            <h2>Participating Office(s)</h2>
            <v-flex xs12 class="horiz-margin-20">
                <v-data-table v-model="officeParticipation"
                :headers="officeParticipationHeaders"
                :items="participatingOffices"
                :single-select="false"
                item-key="userName"
                show-select
                class="elevation-1">
                </v-data-table>
            </v-flex>
            <div>
                <br/>&nbsp;<span style="color:blue;">{{participatingOffMessages}}</span>&nbsp;
                    <v-btn color="primary" dark @click="onDelete">Delete Offices</v-btn>
                    &nbsp;
                    <v-btn color="primary" dark @click="onReload">Refresh Offices</v-btn>
            </div>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import router from '@/router';
import { authTokenService } from '@/services/authTokenService.js';
import { CONSTANTS } from '@/common/constants.js';
import { officeManagementService } from '@/services/officeManagementService.js';
import { authService } from "@/services/authService.js";
import { surveyService } from "@/services/surveyService.js";

export default
{
	data: () => ({
        officename: null,
        officeParticipation: [],
        officeParticipationHeaders: [
          { text: 'Office Name (Click name to edit office contact information)', value: 'officeName', class: 'cellLink' },
          { text: 'Office Abbrev', value: 'officeAbbreviation' },
          { text: 'Agency', value: 'agency' },
          { text: 'Program', value: 'program' },
          { text: 'Field', value: 'field' },
          { text: 'Branch', value: 'branch' },
          { text: 'SurveyType', value: 'surveyType' },
          { text: 'Survey Locked?', value: 'isLocked' },
          { text: 'Volume', value: 'volume' },
					{ text: 'UserName', value: 'userName' }
        ],
        participatingOffices: [],
        message: '',
        participatingOffMessages: null
	}),
	methods:
    {
        onSearchClicked () {
            debugger;
            const me = this;
            me.participatingOffMessages = "Processing please wait..";
            me.participatingOffices = [];
            if(me.officename == "")
                me.officename = null;
            officeManagementService.getAllOfficesOfCurrentVolume(me.officename).then(function (response) {
                if (response && response.data) {
                    for(var i=0;i<response.data.length;i++)
                    {
                        me.participatingOffices.push(response.data[i]);
                    }
                    me.participatingOffMessages=null;
                }
            });
        },
        onDelete ()
        {
            const me = this;
            me.participatingOffMessages="Processing please wait..";
            for(var i=0; i<me.participatingOffices.length; i++)
            {
                if(me.officeParticipation[i].isLocked=='No')
                {
                    if(me.officeParticipation[i].surveyId!=0 && me.officeParticipation[i].officeId !=0)
                    {
                        surveyService.deleteOffice(me.officeParticipation[i].surveyId, me.officeParticipation[i].officeId).then(function (resp) {
                            me.participatingOffMessages = "Selected offices are deleted Successfully, please click reload to refresh";

                        })
                        .catch(function (err) {
                            console.log(err);
                            me.participatingOffMessages = "Not able to delete OfficeId: " + me.officeParticipation[i].officeId + " SurveyId: " + me.officeParticipation[i].surveyId + " " +  err;
                            throw err;
                        });
                    }
                }
            }
            me.participatingOffices = [];
            officeManagementService.getAllOfficesOfCurrentVolume(me.officename).then(function (response){
                if (response && response.data) {
                    for(var i=0;i<response.data.length;i++)
                    {
                        me.participatingOffices.push(response.data[i]);
                    }
                }
            });
        },
        onReload()
        {
           const me = this;
            me.participatingOffMessages="Processing please wait..";
            me.participatingOffices=[];
            officeManagementService.getAllOfficesOfCurrentVolume(me.officename).then(function (response){
                if (response && response.data) {
                for(var i=0;i<response.data.length;i++)
                {
                    me.participatingOffices.push(response.data[i]);
                }
                me.participatingOffMessages=null;
                }
            });
        }
    },
	mounted ()
    {
      this.onReload();
	}
};
</script>

<style scoped>
.survey-container {
  width: 100%;
  margin: 0 auto;
}

.buttons {
  width: 80%;
  margin: 20px auto;
  text-align: center;
}

</style>
